import { module } from 'modujs';
import axios from "axios";
import Ukiyo from "ukiyojs";

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'switch': 'click' } };
        this.target = document.querySelector( this.el.dataset.target );
        this.html = document.getElementsByTagName('html')[0];
        this.destroyInstances = [];

    }
    click(){

        this.activeFilters = [];
        [...this.el.querySelectorAll( '[data-experience-filters="switch"].active' )].forEach( f => {
            this.activeFilters.push( f.dataset.value );
        });

        //document.querySelector( '[data-module-loading-button="experiences-more"]').dataset.params = '?cat=' + this.activeFilters.join( ',' );


        this.el.classList.add( 'loading' );
        this.html.classList.add( 'is-loading' );
        let url = this.el.dataset.href + ( this.activeFilters.length ?  '?tax=' + this.activeFilters.join( ',' )  : '' );

        if( this.controller ){
            this.controller.abort();
        }
        this.controller = new AbortController();
        this.xhr =  axios.get( url , { signal: this.controller.signal } ).then( (response) => {
            const doc = document.createElement("div");
            doc.innerHTML = response.data;
            this.target.innerHTML = doc.querySelector(this.el.dataset.target ).innerHTML;
            this.destroyInstances.push( new Ukiyo( this.target.querySelectorAll("[data-parallax]"), { scale: 1.2, willChange: true } ) );
            this.el.classList.remove( 'loading' );
            this.call('update', false, 'Scroll');
            this.call('updateLazy', false, 'Scroll');
            this.call( 'update', this.target, 'app' );
            this.html.classList.remove( 'is-loading' );
        });


    }
    destroy(){
        this.destroyInstances.forEach( instance => instance.destroy() );
    }
}
